import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '@app/material.module';
import { RowTypePipe } from './row-pipe';
import { GridScenarioComponent } from './grid-scenario.component';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MaterialModule,
    TranslateModule.forChild()
  ],
  declarations: [
    RowTypePipe,
    GridScenarioComponent
  ],
  exports: [
    GridScenarioComponent
  ]
})
export class GridScenarioModule {}
